import styled from 'styled'

const InputError = styled.span`
  color: ${props => props.theme.colors.danger};
  display: inline-block;
  padding-top: ${props => props.theme.spaces.xxs};
`
export default InputError
